import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';

import { DateTypes, RequestStatus, RequestStatusTextPipe } from '@app/shared/types';
import { RequestSummary } from '@app/shared/types/request-summary';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CopyTextDirectiveNew } from '@app/shared/v3/directives/copy-text.directive-new';
import { RequestStatusClassDirective } from '@app/shared/directives/request-status-class.directive';
import { TcDateStandaloneDirective } from '@app/shared/directives/tc-date-standalone.directive';
import { TcCurrencyPipe } from '@app/shared/pipes';
import { RequestStatusTextDirectDepositPipe } from '@app/shared/pipes/request-status-direct-deposit.pipe';
import { ResizeService } from '@app/core/services/resize.service';

@Component({
    selector: 'app-request-summary',
    imports: [
        CommonModule,
        TranslateModule,
        MatExpansionModule,
        CopyTextDirectiveNew,
        RequestStatusClassDirective,
        RequestStatusTextPipe,
        TcDateStandaloneDirective,
        RequestStatusTextDirectDepositPipe,
        TcCurrencyPipe,
    ],
    templateUrl: './request-summary.component.html',
    styleUrls: ['./request-summary.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestSummaryComponent implements OnInit, OnChanges, OnDestroy {
  @Input() requestSummary: RequestSummary;
  @Input() isDetailMode: boolean;
  @Input() isDirectDeposit: boolean = false;
  @Input() amountTitle: string;
  @Input() newRequestStatus: RequestStatus;
  @Input() lastChangeDate: Date;
  expand: boolean = true


  unsubscribeAll$ = new Subject<void>();

  // types
  registerDateType = DateTypes.DateTime;

  constructor(
    private resizeService: ResizeService,
  ) {
    this.checkSizeResize();
    this.handleSize();
  }


  ngOnInit() {
    this.unsubscribeAll$ = new Subject();

    if (this.requestSummary.requestStatus == RequestStatus.PAYMENT) {
      this.scrollToMainContent();
    }
  }

  //==================================
  // #region LIFE CYCLE HOOK
  //==================================
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['newRequestStatus'] && changes['newRequestStatus']['currentValue'] != undefined) {
      this.requestSummary.requestStatus = this.newRequestStatus;
    }
    if (changes['lastChangeDate'] && changes['lastChangeDate']['currentValue'] != undefined) {
      this.requestSummary.statusDateUtc = this.lastChangeDate;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
  //#endregion

  //==================================
  // #region PRIVATE
  //==================================
  private checkSizeResize(): void {
    this.resizeService.onResize().subscribe(() => {
      this.handleSize();
    });
  }

  private handleSize(): void {
    let windowSize = window.innerWidth;
    if (windowSize >= 768) {
      this.expand = true;
    } else {
      this.expand = false;
    }
  }

  private scrollToMainContent(): void {
    setTimeout(() => {
      var elmnt = document.getElementById("depositStepper");
      elmnt.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 500);

  }

  //#endregion

}
